import React, { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Container } from "components";
import { useToaster } from "hooks";
import moment from "moment";
import api from "services/api";

export const PromocodeDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [promocode, setPromocode] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setErrorToaster } = useToaster();

  const fetchPromocodeDetails = async () => {
    try {
      setLoading(true);
      const response = await api.get(`/promocodes/${id}`);
      setPromocode(response?.data?.data);
      console.log("Promocode details:", response?.data?.data);
    } catch (error) {
      console.log("fetchPromocodeDetails error:", error);
      setErrorToaster("Failed to fetch promocode details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchPromocodeDetails();
    }
  }, [id]);

  const getStatusBadge = (status) => {
    const statusClasses = {
      Active: "bg-success",
      Pause: "bg-warning", 
      Stop: "bg-danger"
    };
    return statusClasses[status] || "bg-secondary";
  };

  if (loading) {
    return (
      <Container>
        <div className="content-wrapper">
          <div className="container-xxl flex-grow-1 container-p-y">
            <div className="d-flex justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  if (!promocode) {
    return (
      <Container>
        <div className="content-wrapper">
          <div className="container-xxl flex-grow-1 container-p-y">
            <div className="alert alert-danger">
              <h4>Promocode not found</h4>
              <p>The requested promocode could not be found.</p>
              <Link to="/promocodes" className="btn btn-primary">
                Back to Promocodes
              </Link>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  return (
    <Container>
      <div className="content-wrapper">
        <div className="container-xxl flex-grow-1 container-p-y">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/promocodes">Promocodes</Link>
              </li>
              <li className="breadcrumb-item active">Promocode Details</li>
            </ol>
          </nav>
          
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="card-title mb-0">Promocode Details</h5>
                  <div>
                    <button
                      className="btn btn-warning me-2"
                      onClick={() => navigate(`/editPromocode/${id}`)}
                    >
                      Edit Promocode
                    </button>
                    <button
                      className="btn btn-secondary"
                      onClick={() => navigate("/promocodes")}
                    >
                      Back to List
                    </button>
                  </div>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-bold">Promocode</label>
                        <p className="form-control-plaintext fs-4 text-primary">
                          {promocode.promocode}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-bold">Coupon Percentage</label>
                        <p className="form-control-plaintext fs-4">
                          {promocode.coupon_percentage}%
                        </p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-bold">Expiry Date</label>
                        <p className="form-control-plaintext">
                          {moment(promocode.expiry_date).format("DD-MM-YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label fw-bold">Status</label>
                        <p className="form-control-plaintext">
                          <span className={`badge ${getStatusBadge(promocode.status)} fs-6`}>
                            {promocode.status}
                          </span>
                        </p>
                      </div>
                    </div>
                  </div>

                  <hr />

                  <div className="row">
                    <div className="col-md-6">
                      <h6 className="fw-bold mb-3">Created Information</h6>
                      <div className="mb-2">
                        <label className="form-label fw-bold">Created By</label>
                        <p className="form-control-plaintext">
                          {promocode.creator?.name || "N/A"}
                        </p>
                      </div>
                      <div className="mb-2">
                        <label className="form-label fw-bold">Created On</label>
                        <p className="form-control-plaintext">
                          {moment(promocode.created_at).format("DD-MM-YYYY HH:mm")}
                        </p>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <h6 className="fw-bold mb-3">Updated Information</h6>
                      <div className="mb-2">
                        <label className="form-label fw-bold">Updated By</label>
                        <p className="form-control-plaintext">
                          {promocode.updater?.name || "N/A"}
                        </p>
                      </div>
                      <div className="mb-2">
                        <label className="form-label fw-bold">Updated On</label>
                        <p className="form-control-plaintext">
                          {moment(promocode.updated_at).format("DD-MM-YYYY HH:mm")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
